import { createContext, useContext } from 'react'
import type { User } from 'src/services/apollo/generated/graphql'

export type UserProfileContextType = {
  user: User
  tab: string
  profile: {
    bio?: string
    location?: string
    website?: string
    twitterId?: string
    instagramId?: string
    facebookId?: string
    redditId?: string
    pixivId?: string
  }
  isMyProfile: boolean
}

export const UserProfileContext = createContext<UserProfileContextType>(
  undefined as never,
)

export const useUserProfileContext = () => useContext(UserProfileContext)
